// src/features/commission/components/CommissionStatusBadge.tsx
import type { CommissionStatus } from '../types/commission.types';

export interface CommissionStatusBadgeProps {
  status: CommissionStatus;
}

const STATUS_LABEL: Record<CommissionStatus, string> = {
  pending: 'در انتظار بررسی',
  approved: 'تایید شده',
  settled: 'تسویه شده',
  rejected: 'رد شده',
  paid: 'پرداخت شده',
};

const STATUS_COLOR_VAR: Record<CommissionStatus, string> = {
  pending: 'var(--vania-accent-amber, #f5b942)',
  approved: 'var(--vania-accent-teal, #2fd6a7)',
  settled: 'var(--vania-accent-teal, #2fd6a7)',
  rejected: 'var(--vania-accent-rose, #ff6b81)',
  paid: 'var(--vania-accent-teal, #2fd6a7)',
};

/**
 * Small pill badge mapping a commission's raw status to its Persian
 * label + accent color. Same shape/markup as
 * orders/components/OrderStatusBadge.tsx (label map + color-var map
 * keyed by the union type) — kept local to this feature since the
 * status union (pending/approved/rejected/paid) is commission-specific.
 */
export function CommissionStatusBadge({ status }: CommissionStatusBadgeProps) {
  const color = STATUS_COLOR_VAR[status];

  return (
    <span className="vania-commission-status-badge" style={{ color, borderColor: color }}>
      <span aria-hidden className="vania-commission-status-dot" style={{ backgroundColor: color }} />
      {STATUS_LABEL[status]}
    </span>
  );
}
